export const getSecondMenuMaterialSize = subMenuType => {
  return subMenuType === 2
    ? '375*80'
    : subMenuType === 3
    ? '300*200'
    : '375*375'
}

export const getThirdMenuMaterialSize = (menuType, bannerType) => {
  if (+menuType !== 101) {
    return ''
  }
  return bannerType === 1 ? '375*150' : '240*180'
}
